import { render, staticRenderFns } from "./ScopeSelect.vue?vue&type=template&id=a978aa8e"
import script from "./ScopeSelect.vue?vue&type=script&lang=js"
export * from "./ScopeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports